import React from "react";
import { PageTitle } from "../../PageTitle";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import StatisticsCard from "../../components/StatisticsCard/StatisticsCard";
import Button from "../../components/Button/Button";
import ProductCard from "../../components/ProductCard/ProductCard";
import ApplicationForm from "../../components/ApplicationForm/ApplicationForm";
import Contacts from "../../components/Contacts/Contacts";
import Footer from "../../components/Footer/Footer";
import { IconTarget, IconFlag, IconCheck } from "../../assets/icons/Icon";
import mainPicture from "./pictures/main.jpg";
import aboutUsPicture from "./pictures/about-us.jpg";
import recognitionLetter from "./pictures/recognition-letter.png";
import { productsContent } from "./products.data";
import { scrollToApplication } from "../../hooks/scrollTo";
import {
  MediumHeader,
  MediumHeaderBold,
  SectionHeader,
  BodyText,
} from "../../styles/Typography";
import {
  Container,
  HeroSection,
  MainContainer,
  Cards,
  Header,
  SubHeader,
  HeaderContainer,
  TextLine,
  Text,
  Star,
  TextBrake,
  StatistcsCardTextBrake,
  MainPicture,
  PictureLower,
  PictureUpper,
  PictureInternalCorner,
  ActionRow,
  StatisticsSection,
  Statistics,
  StatisticsTextBlock,
  StatisticsNumber,
  StatisticsText,
  AboutUsSection,
  AboutUsImage,
  AboutUsSectionText,
  AboutUsHeader,
  AboutUsContent,
  AboutUsWorkBox,
  WorksHeader,
  HeaderIcon,
  WorksColumn,
  WorksLine,
  WorkItem,
  WorkItemBlue,
  AboutUsCard,
  AboutUsCardText,
  AboutUsCards,
  AboutUsCardsColumn,
  AboutUsCardsLine,
  AboutUsTextBrake,
  AboutUsDesktopText,
  AboutUsMobileText,
  RecognitionSection,
  RecognitionImage,
  RecognitionTextOuterBox,
  RecognitionTextBlock,
  RecognitionHeading,
  RecognitionText,
  RecognitionButtonBox,
  TrustCardWrapper,
  TrustCard,
  TrustCardHeader,
  WorkingSince,
  ProductsSection,
  ProductsHeader,
  ProductContainer,
  ProductCards,
  ApplicationSection,
  ContactsFooterReveal,
  ContactsSection,
  FooterSection,
} from "./Home.styles";

const Home: React.FC = () => {
  return (
    <Container id="main">
      <PageTitle title="Интеллект-Развитие-Технологии" />
      <HeroSection>
        <MainContainer>
          <HeaderContainer>
            <Header>ООО “Интеллект-Развитие-Технологии”</Header>
            <SubHeader>
              — это компания, объединяющая опыт полевых работ <TextBrake />в
              области цементирования нефтегазовых скважин <TextBrake />с
              передовыми IT-решениями.
            </SubHeader>
          </HeaderContainer>

          <MainPicture $image={mainPicture} aria-hidden="true">
            <PictureLower>
              <img
                src={mainPicture}
                alt=""
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </PictureLower>
            <PictureUpper>
              <img src={mainPicture} alt="" loading="eager" decoding="async" />
            </PictureUpper>
            <PictureInternalCorner />
          </MainPicture>

          <TextLine>
            <Star>*</Star>
            <Text>
              Мы гарантируем, что каждая скважина будет работать <TextBrake />с
              максимальной эффективностью, а Ваши риски — сведены к нулю.
            </Text>
          </TextLine>
          <Cards>
            <StatisticsCard
              number="10+"
              subtitle={
                <>
                  лет опыта <StatistcsCardTextBrake /> в индустрии
                </>
              }
              text="В Вашем распоряжении — аккредитованная лаборатория и профессионалы отрасли"
              backgroundColor="#DCDDE0"
            />
            <StatisticsCard
              number="60+"
              subtitle={
                <>
                  проведенных <StatistcsCardTextBrake /> обучающих курсов
                </>
              }
              text="Мы делимся своими знаниями со всеми. Наши преподаватели — кандидаты технических наук"
              backgroundColor="#4C596EE6"
              textColor="#F2F5F8"
            />
            <StatisticsCard
              number="100+"
              subtitle={
                <>
                  успешных работ <StatistcsCardTextBrake /> по цементированию
                </>
              }
              text="Мы гарантируем надежность проведения всех видов работ по цементированию скважин"
              backgroundColor="#212227E6"
              textColor="#F2F5F8"
            />
          </Cards>

          <ActionRow>
            <Button variant="arrow" onClick={scrollToApplication}>
              Связаться с нами
            </Button>
          </ActionRow>
        </MainContainer>
      </HeroSection>

      <StatisticsSection id="statistics">
        <Statistics>
          <StatisticsTextBlock>
            <StatisticsNumber>100+</StatisticsNumber>
            <StatisticsText>
              проведенных лабораторных тестирований
            </StatisticsText>
          </StatisticsTextBlock>
          <StatisticsTextBlock>
            <StatisticsNumber>15+</StatisticsNumber>
            <StatisticsText>довольных заказчиков</StatisticsText>
          </StatisticsTextBlock>
          <StatisticsTextBlock>
            <StatisticsNumber>4</StatisticsNumber>
            <StatisticsText>инновационных продукта</StatisticsText>
          </StatisticsTextBlock>
          <StatisticsTextBlock>
            <StatisticsNumber>3</StatisticsNumber>
            <StatisticsText>запатентованных разработки</StatisticsText>
          </StatisticsTextBlock>
        </Statistics>
      </StatisticsSection>

      <AboutUsSection id="about">
        <AboutUsImage $image={aboutUsPicture}>
          <img
            src={aboutUsPicture}
            alt="Команда ИРТ за работой"
            loading="lazy"
            decoding="async"
          />
        </AboutUsImage>
        <AboutUsSectionText>
          <SectionHeader>О нас</SectionHeader>
          <AboutUsContent>
            <AboutUsHeader>
              <MediumHeaderBold>
                ООО “Интеллект-Развитие-Технологии” (“ИРТ”)
              </MediumHeaderBold>
              <MediumHeader>
                — это компания с многолетним опытом разработки инновационных
                решений в области цементирования нефтегазовых скважин.
              </MediumHeader>
            </AboutUsHeader>

            <AboutUsCards>
              <AboutUsCardsColumn>
                <AboutUsWorkBox>
                  <WorksHeader>
                    <HeaderIcon $backgroundColor="#5D697C">
                      <IconTarget />
                    </HeaderIcon>
                    <p> Основные направления работы</p>
                  </WorksHeader>
                  <WorksColumn>
                    <WorksLine>
                      <WorkItem>инженерное сопровождение</WorkItem>
                      <WorkItemBlue>лабораторные испытания</WorkItemBlue>
                    </WorksLine>
                    <WorksLine>
                      <WorkItem>ремонтно-изоляционные работы</WorkItem>
                    </WorksLine>
                    <WorksLine>
                      <WorkItemBlue>производство оборудования</WorkItemBlue>
                      <WorkItem>технические консультации</WorkItem>
                    </WorksLine>
                    <WorksLine>
                      <WorkItemBlue>
                        разработка программного обеспечения
                      </WorkItemBlue>
                    </WorksLine>
                    <WorksLine>
                      <WorkItem>разработка изолирующих составов</WorkItem>
                      <WorkItemBlue>обучение персонала</WorkItemBlue>
                    </WorksLine>
                  </WorksColumn>
                </AboutUsWorkBox>
                <AboutUsDesktopText>
                  <MediumHeader>
                    Наши проекты реализуются <AboutUsTextBrake /> на территории
                    РФ и за рубежом.
                  </MediumHeader>
                </AboutUsDesktopText>
              </AboutUsCardsColumn>
              <AboutUsCardsLine>
                <AboutUsCard>
                  <HeaderIcon $backgroundColor="#F2F5F8">
                    <IconFlag />
                  </HeaderIcon>
                  <AboutUsCardText>
                    <h1>*</h1>
                    <BodyText>
                      Мы обеспечиваем безопасность и эффективность выполняемых
                      работ, что позволяет нам занимать лидирующие места в
                      отрасли
                    </BodyText>
                  </AboutUsCardText>
                </AboutUsCard>
                <AboutUsMobileText>
                  <MediumHeader>
                    Наши проекты реализуются <AboutUsTextBrake /> на территории
                    РФ и за рубежом.
                  </MediumHeader>
                </AboutUsMobileText>
              </AboutUsCardsLine>
            </AboutUsCards>
          </AboutUsContent>
        </AboutUsSectionText>
      </AboutUsSection>

      <RecognitionSection id="recognition">
        <ImageGallery
          images={[
            { src: recognitionLetter, alt: "Благодарственное письмо компании" },
          ]}
        >
          {({ openGallery }) => (
            <RecognitionImage
              onClick={() => openGallery(0)}
              $image={recognitionLetter}
            >
              <img
                src={recognitionLetter}
                alt="Благодарственное письмо компании"
                loading="lazy"
                decoding="async"
              />
            </RecognitionImage>
          )}
        </ImageGallery>

        <RecognitionTextOuterBox>
          <TrustCardWrapper>
            <TrustCard>
              <TrustCardHeader>
                <p>Нам доверяют</p>
                <span>
                  <IconCheck />
                </span>
              </TrustCardHeader>
              <p>
                Мы неоднократно получали благодарственные письма от
                компаний-клиентов за высокое качество проведенных нами работ
              </p>
            </TrustCard>
            <WorkingSince>На рынке с 2016 года</WorkingSince>
          </TrustCardWrapper>
          <RecognitionTextBlock>
            <RecognitionHeading>
              <MediumHeaderBold>Признание лидеров отрасли</MediumHeaderBold>
            </RecognitionHeading>
            <RecognitionText>
              <BodyText>
                Мы гордимся тем, что наш вклад в повышение надёжности
                цементирования получил высокую оценку от ООО
                «Газпромнефть‑Заполярье».
              </BodyText>
              <BodyText>
                Совместная работа на Харасавэйском и Бованенковском арктических
                месторождениях показала: наши технологии вращения обсадных
                колонн позволяют достигать максимального замещения растворов
                даже в самых сложных геологических условиях.
              </BodyText>
              <BodyText>
                Это письмо — свидетельство того, что мы умеем решать задачи, от
                которых зависит безаварийная эксплуатация скважин.
              </BodyText>
            </RecognitionText>
            <RecognitionButtonBox>
              <Button variant="arrow" onClick={scrollToApplication}>
                Связаться с нами
              </Button>
            </RecognitionButtonBox>
          </RecognitionTextBlock>
        </RecognitionTextOuterBox>
      </RecognitionSection>

      <ProductsSection id="products">
        <ProductsHeader>
          <SectionHeader>{productsContent.title}</SectionHeader>
          <BodyText>{productsContent.intro}</BodyText>
        </ProductsHeader>
        {productsContent.groups.map((group) => (
          <ProductContainer key={group.id}>
            <h2>{group.title}</h2>
            <ProductCards>
              {group.products.map((product) => (
                <ProductCard
                  key={product.slug}
                  title={product.title}
                  subtitle={product.subtitle}
                  description={product.description}
                  image={product.image}
                  imageFit={product.imageFit}
                  direction={product.direction}
                  to={`/products/${product.slug}`}
                />
              ))}
            </ProductCards>
          </ProductContainer>
        ))}
      </ProductsSection>

      <ContactsFooterReveal data-scroll-reveal-group="true">
        <ApplicationSection id="application" data-scroll-reveal="false">
          <ApplicationForm />
        </ApplicationSection>
        <ContactsSection id="contacts" data-scroll-reveal="false">
          <Contacts />
        </ContactsSection>
        <FooterSection data-scroll-reveal="false">
          <Footer />
        </FooterSection>
      </ContactsFooterReveal>
    </Container>
  );
};

export default React.memo(Home);
